import { useQuery } from '@tanstack/react-query';
import { guidesApi, guidesKeys } from '@/features/guides/api/guides.api';
import type { GuidesSearchParams } from '@/features/guides/utils/searchParams';

export function useGuides(params?: GuidesSearchParams) {
  return useQuery({
    queryKey: guidesKeys.list(params),
    queryFn: () => guidesApi.list(params),
  });
}
